export default __webpack_public_path__ + "static/media/we-havefun.e2e2f362.svg";